import axios  from "axios"
import Vue from "vue"

export default {


    async checkAlreadyExistedUser(data) {
        try{
            const res = await Vue.prototype.falconAxios.post('/users/already-exists', data);
            return Promise.resolve(res.data);

        } catch(e)  {
            return Promise.reject(e);
        }
    },


    async getAppUserRoles() {
        try{
            const res = await axios.get('/user/userRole');
            return Promise.resolve(res.data.data);

        } catch(e)  {
            return Promise.resolve([]);
        }
    },

    async registerUser(registerType, formData) {
        try{
            const res = await Vue.prototype.falconAxios.post(`/users/signup/${registerType}`,formData);
            return Promise.resolve(res.data);
        } catch(e)  {
            return Promise.reject(e);
        }
    },

    async sendOTP(registerType, data) {
        try{
            const res = await axios.post(`/user/send-otp/${registerType}`,data);
            return Promise.resolve(res.data);
        } catch(e)  {
            return Promise.reject(e);
        }
    },


    async verifyOTP(data) {
        try{
            const res = await Vue.prototype.falconAxios.post(`/users/verify-otp`,data);
            return Promise.resolve(res.data);
        } catch(e)  {
            return Promise.reject(e);
        }
    },


    async addUser(data) {
        return await axios.post('user', data)
            .then(result => result.data)
            .catch( error => Promise.reject(error));
    },

    async getUsers(dataOptions, userType, search='', imported = 0) {
        // http://3.218.20.78:3002/api/admin/user?page=1&limit=10
        var url = `user?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(imported == 1)
            url = `${url}&imported=${imported}`
        else
            url = `${url}&status=${userType}`
        if(search != '')
            url = `${url}&search=${search}`
        if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async getLogs(options,search){
        const { page, itemsPerPage, sortBy, sortDesc } = options;
        var url = `activity-log?page=${page}&limit=${itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
        if(sortBy.length)
            url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },

    async updateUser(data) {
        return await axios.put('user', data)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },

    async uploadUsers(data) {
        return await axios.post('user/import', data)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },

    async getFilesData(options, search = '') {
        const { page, itemsPerPage } = options;
        var url = `user/import?page=${page}&limit=${itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },

    async searchUsers(search="") {
        var url = "/option/user?page=1&limit=1000"
        if(search.length > 0)
            url = `${url}&name=${search}`
        return await axios.get(url)
            .then(({data}) => data)
            .catch( error => Promise.reject(error));
    },
    async verifytoken(data) {
        return await axios.post('/forget-password/validate', data)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async resetPassword(data) {
        console.log(data)
        return await axios.put('forget-password/reset-password', data)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },

    async preRegister(data) {
        console.log(data)
        return await axios.post('https://sass-api-prod.dimitra.dev/api/user/pre-register', data)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async setPassword(id, data) {
        console.log(data)
        var url = `/user/pre-register/set-password/${id}`
        return await axios.post(url, data)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
}